// extracted by mini-css-extract-plugin
module.exports = {"leftContent":"_slug__leftContent__vTJ07","rightContent":"_slug__rightContent__qn4yl","trumpCoinTips":"_slug__trumpCoinTips__tncZV"};